module.exports = __webpack_public_path__ + "img/ok-icon-transparent.41f80220.svg";